import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';


// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class CommonListService {
  constructor(private http: HttpClient) {}

  getDocStatusList(): Observable<any> {
    const get_url = baseApiUrl + 'commonList/generic/docStatus';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(data => data),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getCustStatusList(): Observable<any> {
    const get_url = baseApiUrl + 'commonList/generic/custStatus';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(data => data),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }


}
